import React, { useState } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home/Home';
import Search from './components/Search/Search';
import About from './components/About';
import CruiseDetail from './components/Detail/CruiseDetail';
import Booking from './components/Booking/Booking';
import './css/custom.css'
import { CartProvider } from './Context/CartContext';
import { BaseDataProvider } from './Context/BaseDataContext';
import { BreakpointProvider } from 'react-socks';
import { setDefaultBreakpoints } from 'react-socks';

function App() {

  setDefaultBreakpoints([
    { xs: 0 },
    { sm: 640 },
    { md: 768 },
    { lg: 1024 },
    { xl: 1280 }
  ]);

  return (
    <BreakpointProvider>
      <BaseDataProvider>
        <CartProvider >
            <Layout>
              <Route exact path='/' component={Home} />
              <Route path="/details/:token/:masterid/:selecteddate" component={CruiseDetail} />
              <Route path="/details/:token/:masterid" component={CruiseDetail} />
              <Route path='/search/:token?' component={Search} />
              <Route path="/booking/:token/:masterid" component={Booking} />
              <Route path='/about' component={About} />
            </Layout>
        </CartProvider>
      </BaseDataProvider>
    </BreakpointProvider>
  );
}

export default App;
